module.exports = __webpack_public_path__ + "img/sankaku_97_red.bea3043e.png";